import { Observer } from 'mobx-react-lite';
import React from 'react';
import joinClassName from '../../utils/className.utils';
import { renderRenderable } from '../../utils/components.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import { formatSearchString, formatSearchStringButIncludeSpace } from '../../utils/string.utils';
import BaseButton from '../BaseButton/BaseButton';
import BaseInput from '../BaseInput/BaseInput';
import './SearchBar.scss';
var SearchBar = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        _userInput: '',
        get userInput() {
            if (p.form && p.field)
                return p.form[p.field];
            return s._userInput;
        },
        set userInput(v) {
            if (p.form && p.field)
                p.form[p.field] = v.trim();
            else
                s._userInput = v.trim();
        },
        get formattedInput() {
            if (!p.inputIncludeSpace)
                return formatSearchString(s.userInput);
            return formatSearchStringButIncludeSpace(s.userInput);
        },
        handleChange: function () {
            var _a;
            (_a = p.onChange) === null || _a === void 0 ? void 0 : _a.call(p, s.formattedInput);
        },
        handleEnter: function () {
            var _a;
            (_a = p.onEnter) === null || _a === void 0 ? void 0 : _a.call(p, s.formattedInput);
        },
        handleFocus: function () {
            var _a;
            (_a = p.onFocus) === null || _a === void 0 ? void 0 : _a.call(p, s.formattedInput);
        },
        handleBlur: function () {
            var _a;
            (_a = p.onBlur) === null || _a === void 0 ? void 0 : _a.call(p, s.formattedInput);
        },
    }); });
    return React.createElement(Observer, { children: function () {
            var _a, _b, _c;
            return (React.createElement("div", { className: joinClassName('SearchBar', p.className), "data-cy": p.dataCy },
                React.createElement(BaseInput, { form: s, field: "userInput", type: "search", onChange: s.handleChange, onFocus: s.handleFocus, onBlur: s.handleBlur, onEnter: s.handleEnter, placeholder: p.placeholder, autoComplete: (_a = p.autoComplete) !== null && _a !== void 0 ? _a : 'off', autoCorrect: (_b = p.autoCorrect) !== null && _b !== void 0 ? _b : 'off', autoCapitalize: (_c = p.autoCapitalize) !== null && _c !== void 0 ? _c : 'off', autoFocus: p.autoFocus }),
                React.createElement("div", { className: "SearchBarSubmitButton" }, p.submitButton ? renderRenderable(p.submitButton) : React.createElement(BaseButton, { appearance: "icon", icon: "search", onClick: s.handleChange }))));
        } });
};
export default SearchBar;
